import React from 'react';
import { useLocation } from 'react-router-dom';
import Menu from '../components/menu';
import Footer from '../components/footer';

function AboCancel() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sessionId = searchParams.get('session_id'); // Récupère l'ID de session si besoin

  return (
    <div className="flex flex-col min-h-screen">
      <Menu />
      <div className="flex-1 flex flex-col items-center justify-center bg-gray-100 p-4">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full">
          <h1 className="text-3xl font-bold text-red-600 mb-4">Abonnement non validé</h1>
          <p className="text-lg text-gray-700 mb-4">Votre compte Premium n'a pas été validé.</p>
          {/*sessionId && <p className="text-sm text-gray-500">Session ID : {sessionId}</p>
          <img src="/assets/images/success.png" alt="Success" className="mt-4 w-32 h-32 mx-auto" />
          */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboCancel;